import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/index';
import { ProfileService } from '../services/util/profile.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private profileService = inject(ProfileService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.profileService.getUserToken();

    if (req.headers.get('skip')) {
      return next.handle(req);
    }
    const newReq = req.clone({
      withCredentials: true,
      ...(token
        ? {
            headers: new HttpHeaders({
              Authorization: 'Bearer ' + token,
            }),
          }
        : {}),
    });
    return next.handle(newReq);
  }
}
